import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

function MiddleCampagin() {
  return (
    <>
      <div className="container max-w-7xl mx-auto">
        <div className="h-[405.7px] overflow-hidden rounded-[15px] mt-5">
          <LazyLoadImage
            className="w-full h-[405.7px] object-cover"
            src="https://i.ibb.co/gbjS9W2q/il-1140x-N-3667423140-lxsc.webp"
            alt="Your Image"
          />
        </div>
      </div>
    </>
  );
}

export default MiddleCampagin;
